export default __webpack_public_path__ + "static/inline-edit-dont-0e04473ca349bb3492337e6d55e67d53243eef5d2ae4d7f9d5c08fbbbae4f3ac.png";